<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <section-header
          :title="title"
        />
      </div>
    </div>
    <div class="wrapper-content">
      <slot name="content"/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: true,
    },
  },
}
</script>

<style scoped>
.btn-light {
  background: none;
  transition: none;
}
.btn-light:hover {
  background: #E5E5E5;
}

.wrapper-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/WrapperDocRef.vue